<template>
  <article class="able-feature">
    <i :class="item.icon" class="able-feature__icon" aria-hidden="true" />
    <h3 class="able-feature__title">{{ item.title }}</h3>
    <p class="able-feature__text">{{ item.summary }}</p>
  </article>
</template>

<script>
export default {
  name: "AbleFeatureCard",
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
.able-feature {
  background: var(--background-color2);
  padding: clamp(24px, 4vw, 35px) clamp(18px, 3vw, 25px);
  border-radius: 18px;
  text-align: center;
  height: 100%;
  border: 1px solid var(--border-color-hover1, #e5e7eb);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.06);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.able-feature:hover {
  transform: translateY(-8px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.12);
}

.able-feature__icon {
  display: block;
  font-size: 2.2rem;
  color: var(--border-color-hover);
  margin-bottom: 15px;
}

.able-feature__title {
  margin: 0 0 10px;
  font-size: 1.2rem;
  font-weight: 700;
  color: var(--text-color1);
}

.able-feature__text {
  margin: 0;
  font-size: 0.95rem;
  line-height: 1.55;
  color: var(--text-color1);
  opacity: 0.82;
}
</style>
